import { render, staticRenderFns } from "./FollowBtn.vue?vue&type=template&id=06a90c63&scoped=true&"
import script from "./FollowBtn.vue?vue&type=script&lang=js&"
export * from "./FollowBtn.vue?vue&type=script&lang=js&"
import style0 from "./FollowBtn.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FollowBtn.vue?vue&type=style&index=1&id=06a90c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a90c63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a90c63')) {
      api.createRecord('06a90c63', component.options)
    } else {
      api.reload('06a90c63', component.options)
    }
    module.hot.accept("./FollowBtn.vue?vue&type=template&id=06a90c63&scoped=true&", function () {
      api.rerender('06a90c63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/a-kit/buttons/FollowBtn.vue"
export default component.exports